import { Grid, Stack } from '@chakra-ui/react';
import { Paragraph } from 'ui-components';
import {
  MetricCard,
  PlatformMetrics as PlatformMetricsType,
} from '~/components/CreatorChannelMetrics';

import { usePlatformAnalyticsStore } from './usePlatformAnalyticsStore';

interface Props {
  metricsToShow: PlatformMetricsType[];
}

export const PlatformMetrics = ({ metricsToShow }: Props) => {
  const { platform, selectedMetrics, setSelectedMetrics } =
    usePlatformAnalyticsStore();

  if (!platform) return null;

  return (
    <Stack spacing={2}>
      <Paragraph size="lg" fontWeight="medium">
        Talent & Channel Metrics
      </Paragraph>

      <Grid templateColumns="repeat(auto-fit, minmax(300px, 1fr))" gap={4}>
        {metricsToShow.map((metric) => (
          <MetricCard
            key={metric.title}
            metricTitle={metric.title}
            metricValue={metric.value}
            metricTransformValue={metric.transformValue}
            isChecked={selectedMetrics.includes(metric.title)}
            onChange={() => setSelectedMetrics(metric.title)}
          />
        ))}
      </Grid>
    </Stack>
  );
};
